module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-dialog modal-container"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(!_vm.hideHeader) ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._t("modal-header", [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n              ")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("modal-footer", [(_vm.isCloseButton) ? _c('button', {
    staticClass: "btn cl-btn close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.closeTitle) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn cl-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.okDisabled
    },
    on: {
      "click": function($event) {
        return _vm.$emit('ok')
      }
    }
  }, [(!_vm.okBusy) ? _c('span', [_vm._v(_vm._s(_vm.okTitle))]) : _c('LoadingBounce')], 1)])], 2)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05580bca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomModal.vue
// module id = 1549
// module chunks = 1